import { useParams } from "react-router";

export default function useNotebookParams() {
    const params = useParams<{ pageId: string; notebookId: string }>();

    const notebookId = params.notebookId ? Number(params.notebookId) : null;
    const pageId = params.pageId ? Number(params.pageId) : null;

    return {
        notebookId,
        pageId,
    };
}
